var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function addBodyClassName() {
  var className = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var isVisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var CLASSNAME_SEPARATOR = "";
  if (typeof document === "undefined") {
    return;
  }
  var bodyClassNames = document && document.body && document.body.className || "";
  var hasOverflowClassName = bodyClassNames.indexOf(className) !== -1;
  if (hasOverflowClassName && !isVisible) {
    document.body.className = bodyClassNames.replace(className, "");
  } else if (!hasOverflowClassName && isVisible) {
    document.body.className = [].concat(_toConsumableArray(bodyClassNames.split(CLASSNAME_SEPARATOR)), [className]).join(CLASSNAME_SEPARATOR);
  }
}
__name(addBodyClassName, "addBodyClassName");
export {
  addBodyClassName
};
